(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-ons-how-to"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sistaco-how-to')) {
    customElements.define('sistaco-how-to', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-po-tab]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.poTab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = this.tabs[1 - index];
            if (event.key === 'Home') next = this.tabs[0];
            if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
            if (next) { event.preventDefault(); this.selectTab(next.dataset.poTab); next.focus(); }
          });
        });
        this.querySelectorAll('[data-po-step]').forEach(step => step.addEventListener('click', () => this.selectStep(step)));
        this.pausedByUser = new WeakSet();
        this.querySelectorAll('video').forEach(video => {
          video.addEventListener('pause', () => {
            if (this.inView && !video.closest('[data-po-video]').hidden && !video.ended && !document.hidden) this.pausedByUser.add(video);
          });
          video.addEventListener('play', () => this.pausedByUser.delete(video));
        });
        this.selectTab('apply');
        this.preloadObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.querySelectorAll('[data-po-video] video').forEach(video => { video.preload = 'auto'; });
          this.preloadObserver.disconnect();
        }, {rootMargin: '300px'});
        this.preloadObserver.observe(this);
        this.visibilityHandler = () => this.updatePlayback();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.videoObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updatePlayback();
        }, { threshold: 0.01 });
        this.videoObserver.observe(this.querySelector('.po-howto__media'));
      }
      disconnectedCallback() {
        this.videoObserver?.disconnect();
        this.preloadObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
      updatePlayback() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('[data-po-video]').forEach(media => {
          const video = media.querySelector('video');
          if (!video) return;
          if (media.hidden || !this.inView || document.hidden) video.pause();
          else if (!reducedMotion && !video.ended && !this.pausedByUser.has(video) && video.paused) video.play().catch(() => {});
        });
      }
      selectTab(mode) {
        if (this.activeMode === mode) return;
        this.activeMode = mode;
        this.querySelectorAll('[data-po-video]').forEach(media => {
          media.hidden = media.dataset.poVideo !== mode;
          const video = media.querySelector('video');
          if (video && !media.hidden && video.ended) video.currentTime = 0;
        });
        this.updatePlayback();
        this.tabs.forEach(tab => {
          const selected = tab.dataset.poTab === mode;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[data-po-panel]').forEach(panel => {
          panel.hidden = panel.dataset.poPanel !== mode;
          if (!panel.hidden) this.selectStep(panel.querySelector('[data-po-step]'));
        });
      }
      selectStep(selected) {
        if (!selected) return;
        const panel = selected.closest('[data-po-panel]');
        panel.querySelectorAll('[data-po-step]').forEach(step => step.setAttribute('aria-pressed', String(step === selected)));
        this.querySelectorAll('[data-po-media]').forEach(media => { media.hidden = media.dataset.poMedia !== selected.dataset.poStep; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
